import { MyPermission } from '../../models/myPermission'
import { MyPermittedAllocation } from '../../services/my-permitted-allocations/my-permitted-allocations.service'
import {
  ActiveAllocationCurrentUser,
  ActiveAllocationManagerPayload,
} from '../../services/active-allocation-manager/active-allocation-manager.service'
import { EventTypeSelect } from '../../models/EventTypeSelect'

export class ResetUserState {
  static readonly type = '[User] Reset State'
}

export class SetSelectedNodes {
  static readonly type = '[User] Set Selected Nodes'
  constructor(public selectedNodes: any[]) {}
}

export class DoReloadPage {
  static readonly type = '[User] Do Reload Page'
}

export class SetPermissions {
  static readonly type = '[User] Set Permissions'
  constructor(public permissions: MyPermission[]) {}
}

export class LoadPermissions {
  static readonly type = '[User] Load Permissions'
}

export class SetPermittedAllocations {
  static readonly type = '[User] Set Permitted Allocations'
  constructor(public allocations: MyPermittedAllocation[]) {}
}

export class LoadPermittedAllocations {
  static readonly type = '[User] Load Permitted Allocations'
}

export class SetActiveAllocation {
  static readonly type = '[User] Set Active Allocation'
  constructor(public payload: ActiveAllocationManagerPayload) {}
}

export class LoadActiveAllocationCurrentUser {
  static readonly type = '[User] Load Active Allocation Current User'
}

export class SetActiveAllocationCurrentUser {
  static readonly type = '[User] Set Active Allocation Current User'
  constructor(public payload: ActiveAllocationCurrentUser | null) {}
}

export class LoadEventTypeSelect {
  static readonly type = '[User] Load EventTypeSelect'
}

export class SetEventTypeSelect {
  static readonly type = '[User] Set EventTypeSelect'
  constructor(public payload: EventTypeSelect[]) {}
}
